<template>
    <v-card flat>
        <v-card-text>

            <v-container fluid class="pt-2">
                <v-row row>
                    <v-col cols="12" md="10" lg="8">

                        <v-alert class="pa-2 body-2" type="info">
                            <span>
                                Business rules are applied to all projects automatically
                            </span>
                        </v-alert>

                        <segment-visualizer
                            class="mt-8 cursor-pointer"
                            help="panel-settings-business-rules"
                            :json-query="data.business_rules_json_query"
                            :json-filter="data.business_rules_json_filter"
                            :show-business-rules="false"
                            :disable-sub-panel-filtering="true"
                            :definition-builder-open="definitionBuilderOpen"
                            title="Business Rules"
                            title-color="#F57F17"
                            title-icon="mdi-gavel"
                            empty-segment-warning="Business rules have not been setup."
                            @change="sampleDefinitionUpdated"
                            @cancel="sampleDefinitionCancelled"
                        ></segment-visualizer>

                        <!-- ROUTING CONTROLS -->
                        <title-card class="mt-4" title="Routing" side-icon="mdi-routes"
                                    :hide-contents="!data.routing_enabled"
                                    v-if="hasFeature('project_routing')"
                                    help="panel-settings-routing">
                            <template v-slot:buttons>
                                <v-tooltip left color="primary">
                                    <template v-slot:activator="{ on }">
                                        <v-sheet v-on="on" color="transparent">
                                            <v-switch v-model="data.routing_enabled"
                                                      class="mt-4"
                                                      dense
                                                      @change="emit"
                                            ></v-switch>
                                        </v-sheet>
                                    </template>
                                    <span>Turn internal routing on / off</span>
                                </v-tooltip>
                            </template>

                            <div class="d-flex justify-space-between">

                                <div style="width: 500px;">
                                    <v-slider v-model="data.max_routing_attempts"
                                              class="mt-8"
                                              :min="1"
                                              :max="5"
                                              hint="Max routing attempts per session"
                                              thumb-color="primary"
                                              persistent-hint
                                              ticks
                                              append-icon="mdi-plus"
                                              prepend-icon="mdi-minus"
                                              @input="emit"
                                    >
                                    </v-slider>
                                </div>

                                <div class="mr-6">
                                    <flip-number :value="data.max_routing_attempts"
                                                 :highlight-color="routingColor"
                                                 color="#888"
                                                 size="large"
                                                 :no-skip="true"
                                    ></flip-number>
                                </div>

                            </div>


                        </title-card>

                    </v-col>
                </v-row>
            </v-container>

            <json v-if="false" :data="data"/>
        </v-card-text>
    </v-card>
</template>

<script>

import SegmentVisualizer from '../../Segments/components/SegmentVisualizer';
import TitleCard from "../../../components/UI/TitleCard";
import Json from 'vue-json-pretty';
import FlipNumber from "../../../components/UI/FlipNumber";

export default {

    components: {
        FlipNumber,
        SegmentVisualizer,
        Json,
        TitleCard
    },

    props: {
        jsonQuery: {
            required: true,
            type: String | null
        },
        jsonFilter: {
            required: true,
            type: String | null
        },
        routingEnabled: {
            required: true,
            type: Boolean,
            default: true,
        },
        maxRoutingAttempts: {
            required: true,
            type: Number,
            default: 3,
        },
        errorMessages: {
            required: false,
            type: Object,
            default: () => {
                return {
                    name: []
                }
            }
        },
    },

    data() {
        return {
            definitionBuilderOpen: false,
            definitionPickerOpen: false,
            data: {
                business_rules_json_query: null,
                business_rules_json_filter: null,
                routing_enabled: true,
                max_routing_attempts: 3
            },
        }
    },

    watch: {
        jsonQuery(newValue) {
            this.data.business_rules_json_query = newValue;
        },
        jsonFilter(newValue) {
            this.data.business_rules_json_filter = newValue;
        },
        routingEnabled(newValue) {
            this.data.routing_enabled = newValue;
        },
        maxRoutingAttempts(newValue) {
            this.data.max_routing_attempts = newValue;
        }
    },

    computed: {
        routingColor() {

            const colors = [
                '#43A047',
                '#2E7D32',
                '#FBC02D',
                '#FF8F00',
                '#E53935',
            ]

            return colors[this.data.max_routing_attempts - 1];
        }
    },

    methods: {

        sampleDefinitionUpdated(sampleDefinition) {
            this.data = Object.assign(this.data, {
                business_rules_json_query: sampleDefinition.json_query,
                business_rules_json_filter: sampleDefinition.json_filter
            });
            this.definitionBuilderOpen = false;
            this.emit();
        },

        emit() {
            this.$emit('change', this.data);
        },

        sampleDefinitionCancelled() {
            this.definitionBuilderOpen = false;
        },

        sampleDefinitionSelected(definition) {
            this.definitionPickerOpen = false;
            this.data.business_rules_json_query = definition.json_query;
            this.data.business_rules_json_filter = definition.json_filter;
        }
    },

    created() {
        this.data.business_rules_json_query = this.jsonQuery;
        this.data.business_rules_json_filter = this.jsonFilter;
        this.data.routing_enabled = this.routingEnabled;
        this.data.max_routing_attempts = this.maxRoutingAttempts;

        if (!this.jsonQuery) {
            this.$emit('error', 'Segment must be completed');
        }
    }
}
</script>
